import { decodeJwtClaims, ppUserIdFromClaims, ppUserRoleFromClaims } from "../auth/jwt";

export interface WorklistIdentity {
  userId: string | undefined;
  userRole: string | undefined;
}

/**
 * Decodes the native Patient Priority Index module's `userId`/`userRole`
 * props from the SAME bearer `getAccessToken` actually sends to PP-API — the
 * Provider Portal bearer (`getPpToken(...)`), never the primary Entra/
 * Pathways session token directly.
 *
 * Grill fix: for an SSO/Pathways provider with a stashed *linked* PP token,
 * the primary session bearer and the PP bearer carry DIFFERENT `sub` claims.
 * PP-API's `IsUserValid`/`AuthEnabledProviderList` validate `userId` against
 * the *bearer's* `sub` — decoding `userId` from the primary token while
 * sending the PP bearer on the wire mismatches the two and 403s. Mirrors
 * MemberProfilePage.tsx's `identityToken`/`nativeUserId` pattern (there via
 * `resolveCreateAuthIdentityToken`; simpler here since the worklist route
 * never renders the module until `useWorklistAccessGate` already confirms a
 * real PP bearer is present — no pending-sentinel window to account for).
 */
export function resolveWorklistIdentity(
  ppBearerToken: string | undefined,
): WorklistIdentity {
  if (!ppBearerToken) return { userId: undefined, userRole: undefined };
  const claims = decodeJwtClaims(ppBearerToken);
  return {
    userId: ppUserIdFromClaims(claims),
    userRole: ppUserRoleFromClaims(claims) ?? "PROVIDER",
  };
}
